<template>
    <div class="d-flex w-100 flex-column">
        <div class="font-italic">
            <h3>{{ summaryName }}</h3>
        </div>
        <div class="row flex-grow-1">
            <div
                v-for="key in Object.keys(specifications)"
                :key="key"
                class="col-md-6"
            >
                <div class="row">
                    <div class="text-left col-6">
                        <label class="font-weight-bold">{{ key }}:</label>
                    </div>
                    <div class="text-left col-6">
                        <label>{{ getSpecificationValue(key) }}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center font-italic flex-grow-1">
            {{ additionalInformation }}
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductInformation",
    props: {
        specifications: {
            type: Object,
            required: true
        },
        isDevice: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        additionalInformation() {
            return this.specifications["Additional Information"];
        },
        summaryName() {
            return this.isDevice
                ? "Technical specifications"
                : "Plan specifications";
        }
    },
    methods: {
        getSpecificationValue(key) {
            return this.specifications[key];
        }
    }
};
</script>
